/**
 * Model for API FileSummary Model
 */
export class FileLink {
  /**
   * Identifier of the file
   */
  id: number;

  /**
   * Filename
   */
  name: string;

  /**
   * Remote path
   */
  path: string;

  /**
   * Mimetype of the file, autodetected by the server
   */
  mimeType: string;

  /**
   * Content size of the file
   */
  size: number;

  constructor(attributes: Partial<FileLink> = {}) {
    Object.assign(this, attributes);
  }

  isImage(): boolean {
    return this.mimeType && this.mimeType.includes('image');
  }
}
